import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericRepository } from "../../generic-repository/GenericRepository";
import { ResponseModel } from "../../../models/SharedModels/response.model";
import { environment } from "../../../../environments/environment";
import { ILetterHeadRepository } from "./ILetterHeadRepository";
import { LetterHead } from "../../../models/HR/LetterHead/letter-head.model";

@Injectable()
export class LetterHeadRepository extends GenericRepository<LetterHead> implements ILetterHeadRepository {
 
  url: string = environment.urlAddress;
  constructor(protected _http: HttpClient) {
      super(_http, 'api/LetterHead', environment.urlAddress);
    }   
    GetAll(currentPage: number, recordsPerPage: number, filterText: string): Observable<any> {      
        filterText = filterText.split('/').join('~');   
        return this.Get('/SelectAll' + '/' + currentPage + '/' + recordsPerPage + '/' + filterText).pipe(map(this.extractData), catchError(this.handleError));
    }
    SaveRec(item: LetterHead): Observable<ResponseModel> {
        return this.PostData('/SaveRec', item).pipe(map(this.extractData), catchError(this.handleError));
    }
    LoadNavRec(navType: number, currentIndex: number): Observable<ResponseModel> {
        return this.GetById('/NavRec/' + navType + '/' + currentIndex).pipe(map(this.extractData), catchError(this.handleError));
    }
    LoadRec(code: string): Observable<ResponseModel> {
        return this.GetById('/GetRec/' + code).pipe(map(this.extractData), catchError(this.handleError));
    }
    DeleteRec(code: string): Observable<ResponseModel> {
        return this.Delete('/DeleteRec/' + code).pipe(map(this.extractData), catchError(this.handleError));
    }
    PrintLetter(employeeCode: string, letterHeadCode: string): Observable<ResponseModel> {
        return this.GetById('/PrintLetter/' + employeeCode + '/' + letterHeadCode).pipe(map(this.extractData), catchError(this.handleError));
    }
    PdfDownload(employeeCode: string, letterHeadCode: string): Observable<ResponseModel> {
        return this.GetById('/PdfDownload/' + employeeCode + '/' + letterHeadCode).pipe(map(this.extractData), catchError(this.handleError));
    }
}